import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box,
} from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from '../styles';

export interface NewGroupModalProps {
    open: boolean;
    onClose: () => void;
    title?: string;
    message?: string;
    confirmText?: string;
}

function NewGroupModal({
    open,
    onClose,
    title = 'Restaurant group successfully created',
    message = "Group created - catalog disabled until the catalog's manager activates it.",
    confirmText = 'OKAY',
}: NewGroupModalProps) {
    const classes = useStyles();

    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="group-created-title">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Box className={clsx(classes.mTop5, classes.mBot20)}>
                    <Typography variant="body1">{message}</Typography>
                </Box>
                <DialogActions>
                    <Button color="primary" variant="contained" onClick={onClose} autoFocus>
                        {confirmText}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}

export default NewGroupModal;
